<template>
	<div v-bind:class="['dashboard', routeClass ]">
		<!-- Top and side navigation -->
        <Navbar
			v-bind:tabColor="tabColor">
		</Navbar>
		<Sidebar
			@sidebarWidth="setSidebarWidth"
			v-bind:sidebar="routeClass"
			v-bind:tabColor="tabColor">
		</Sidebar>

		<div class="content">
            <router-view @tabColor="setTabColor">
            </router-view>
        </div>
	</div>
</template>

<script>
import { mapActions } from 'vuex'

import Navbar from './navbar/Navbar'
import Sidebar from './sidebar/Sidebar'
import RouteMixin from './mixin/route'

export default {
	name: 'dashboard',
	mixins: [ RouteMixin ],

	mounted() {

	},

	data() {
		return {
			tabColor: null,
			sidebarWidth: 200
		}
	},

	methods: {
		setTabColor(c) {
			this.tabColor = c
		},
		setSidebarWidth(w) {
			this.sidebarWidth = w
		}
	},

	components: {
		Navbar,
		Sidebar
	}
}
</script>

<style lang="scss" scoped>
@import "style-config.scss";
@import "style.scss";
</style>
